import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "invite",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin"])
  },
  data() {
    return {
      friendList: null,
      isLoading: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.isLoading = true;
          const friendInfo = await this.geteRankingFriend();
          if (!friendInfo) {
            this.isLoading = false;
            return;
          }
          this.isLoading = true;
          this.friendList = friendInfo.list;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["geteRankingFriend"]),
    onShare() {
      this.hapticFeedback();
      const content = `✅Here, your judgment turns into real rewards.
💥Go bold and claim up to 100x returns!💸`;
      const url = `https://t.me/share/url?text=${encodeURIComponent(content)}&url=https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}`;
      this.WebApp.openTelegramLink(url);
    },
    onCopy() {
      this.hapticFeedback();
      const that = this;
      const content = `✅Here, your judgment turns into real rewards.
💥Go bold and claim up to 100x returns!💸`;
      const url = `https://t.me/${this.settingInfo.botname}/app?startapp=ref_${this.userInfo.ref_code}\n${content}`;
      this.$copyText(url).then(function (e) {
        that.$toasted.clear();
        that.$toasted.success(that.$lang("Copy Success!"));
      }, function (e) {});
    }
  }
};